import { createAction } from '@reduxjs/toolkit';

export const setWarehouseFilter = createAction('setWarehouseFilter');
export const resetWarehouseFilter = createAction('resetWarehouseFilter');
